import { useIntl, FormattedMessage } from "react-intl";

import {
    BannerAlert,
    BannerProps
} from "@/components/wpl/banner-alert/src/banner-alert";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

export const JPDBanner = () => {
    const intl = useIntl();

    const gwp6473JpdPremiumBanner = checkFeatureFlagGate(
        featureFlags.gwp6473JpdPremiumBanner
    );
    const gwp7456JpdStateOfProductBanner = checkFeatureFlagGate(
        featureFlags.gwp7456JpdStateOfProductBanner
    );
    const gwp8038JpdBannerWebinar = checkFeatureFlagGate(
        featureFlags.gwp8038JpdBannerWebinar
    );

    const gwp9038JdpAIWebinarBanner = checkFeatureFlagGate(
        featureFlags.gwp9038JdpAIWebinarBanner
    );

    const jpdBannerMessagesWebinar: BannerProps = {
        identifier: "JPDPageTemplate.webinar-announcement",
        text: (
            <FormattedMessage
                id="JPDPageTemplate.banner-alert.state-of-product-webinar-announcement"
                defaultMessage="<strong>State of Product 2026:</strong> Register for the webinar to hear the surprising findings!"
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-webinar-announcement.link-text",
            defaultMessage: "Register now →"
        }),
        linkUrl: useLocalizedHref("/webinars/software/state-of-product-2026"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Register now",
            "data-label-english": "Register now",
            "data-track-event":
                "jpdPageTemplate.bannerAlert.stateOfProductWebinarAnnouncement.registerNow"
        }
    };

    const jpdBannerMessagesStateOfProduct: BannerProps = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: (
            <FormattedMessage
                id="JPDPageTemplate.banner-alert.state-of-product-announcement"
                defaultMessage="<strong>State of Product 2026:</strong> Find out what 1000+ product teams think in our newest research report."
                values={DEFAULT_VALUES}
            />
        ),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.state-of-product-announcement.link-text",
            defaultMessage: "Read now →"
        }),
        linkUrl: useLocalizedHref(
            "/software/jira/product-discovery/resources/state-of-product-2026"
        ),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Read now",
            "data-label-english": "Read now",
            "data-track-event":
                "jpdPageTemplate.bannerAlert.stateOfProductAnnouncement.readNow"
        }
    };

    const jpdBannerMessagesAIWebinar: BannerProps = {
        identifier: "JPDPageTemplate.ai-webinar-annnouncement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.ai-webinar-annnouncement",
            defaultMessage: "AI product strategy: How to build & win today."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Get the Details →"
        }),
        linkUrl: useLocalizedHref(
            "/webinars/software/jira-product-discovery-ai-webinar"
        ),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Get the Details",
            "data-label-english": "Get the Details",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };

    const jpdBannerMessagesPremium: BannerProps = {
        identifier: "JPDPageTemplate.premium-announcement",
        text: intl.formatMessage({
            id: "JPDPageTemplate.banner-alert.premium-announcement",
            defaultMessage:
                "Jira Product Discovery Premium is now available! Get more visibility, control, and support to build products at scale."
        }),
        linkText: intl.formatMessage({
            id: "JPDPageTemplate.link-text",
            defaultMessage: "Learn more →"
        }),
        linkUrl: useLocalizedHref("/software/jira/product-discovery/premium"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more",
            "data-track-event": "jpdPageTemplate.announcementBanner.learnMore"
        }
    };

    if (gwp9038JdpAIWebinarBanner) {
        return <BannerAlert {...jpdBannerMessagesAIWebinar} />;
    }

    if (gwp8038JpdBannerWebinar) {
        return <BannerAlert {...jpdBannerMessagesWebinar} />;
    }
    if (gwp7456JpdStateOfProductBanner) {
        return <BannerAlert {...jpdBannerMessagesStateOfProduct} />;
    }
    if (gwp6473JpdPremiumBanner) {
        return <BannerAlert {...jpdBannerMessagesPremium} />;
    }

    return null;
};
